'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_ROLE_CATEGORIES_REQUEST: 'FETCH_ROLE_CATEGORIES_REQUEST',
    FETCH_ROLE_CATEGORIES_SUCCEEDED: 'FETCH_ROLE_CATEGORIES_SUCCEEDED',
    FETCH_ROLE_CATEGORIES_FAILED: 'FETCH_ROLE_CATEGORIES_FAILED'
};

function fetchRoleCategoriesRequest() {
    return {
        type: actionTypes.FETCH_ROLE_CATEGORIES_REQUEST
    };
}

function fetchRoleCategoriesSucceeded(roleCategories) {
    return {
        type: actionTypes.FETCH_ROLE_CATEGORIES_SUCCEEDED,
        roleCategories: roleCategories
    };
}

function fetchRoleCategoriesFailed() {
    return {
        type: actionTypes.FETCH_ROLE_CATEGORIES_FAILED
    };
}

var actionCreators = {
    fetchRoleCategoriesRequest: fetchRoleCategoriesRequest,
    fetchRoleCategoriesSucceeded: fetchRoleCategoriesSucceeded,
    fetchRoleCategoriesFailed: fetchRoleCategoriesFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/roleCategories.js
// module id = 342
// module chunks = 0